import { render } from "./list_project.vue?vue&type=template&id=73f2ee58&scoped=true"
import script from "./list_project.vue?vue&type=script&lang=js"
export * from "./list_project.vue?vue&type=script&lang=js"

import "./list_project.vue?vue&type=style&index=0&id=73f2ee58&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73f2ee58"]])

export default __exports__